export const BANNER_VIEW_TYPES = [
    { value: 'website', label: 'Website' },
    { value: 'mobile_app', label: 'Mobile App' }
]

export const BANNER_PAGE_TYPES = [
    { value: 'home', label: 'Home' },
    { value: 'default', label: 'Default' },
]

export const BANNER_STATUSES = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' }
]

export const labelFor = (list, value) => list.find((i) => i.value === value)?.label || value